/**
 * 탭뷰 팁 캐러셀 인덱스 로직 — Phaser 무의존 순수 함수. TipCarouselView가 소비한다.
 * 진입 시 랜덤 시작 + `◀`/`▶` 순환을 결정론적으로 계산해 단위테스트로 고정한다(rng 주입).
 */

/**
 * 진입 시 표시할 랜덤 시작 인덱스 — `[0, count)`. count<=0이면 0(팁 없음).
 * @param rng 0~1 난수(보통 Math.random). 1.0 경계도 마지막 인덱스로 clamp(방어적).
 */
export function randomStartIndex(count: number, rng: () => number): number {
  if (count <= 0) return 0;
  return Math.min(count - 1, Math.floor(rng() * count));
}

/**
 * prev(-1)/next(+1) 순환 인덱스. count<=0이면 0, count==1이면 항상 0.
 * 범위 밖 index가 들어와도 모듈러로 정규화한다(음수 안전).
 */
export function stepTipIndex(index: number, count: number, dir: 1 | -1): number {
  if (count <= 0) return 0;
  return (((index + dir) % count) + count) % count;
}
